module.exports = __webpack_public_path__ + "img/aqs_img_03.11cdfe6e.jpg";